import { render, staticRenderFns } from "./TermsOfServices.vue?vue&type=template&id=3b9edae4&scoped=true"
import script from "./TermsOfServices.vue?vue&type=script&lang=js"
export * from "./TermsOfServices.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServices.vue?vue&type=style&index=0&id=3b9edae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9edae4",
  null
  
)

export default component.exports